import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const StatCard = ({ icon, color, title, value, subtitle }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="stat-card"
    >
      <div className={`stat-icon ${color}`}>
        <SafeIcon icon={`Fi${icon}`} />
      </div>
      
      <div className="stat-content">
        <div className="stat-value">{value}</div>
        <div className="stat-title">{subtitle}</div>
      </div>
    </motion.div>
  );
};

export default StatCard;